class Radios extends HTMLElement {
    constructor() {
        super();
        // this.handleShowMoreColorsClick = this.handleShowMoreColorsClick.bind(this);
    }
    connectedCallback() {
        (this.current_value = this.querySelector(".radios--option-current")),
        (this.current_color_link = this.querySelector(".shop-by-color")),
            (this.inputs = this.querySelectorAll("input")),
            (this.filter = this.getAttribute("data-filter")),
            (this.is_swatches = "true" === this.getAttribute("data-is-swatches")),
            (this.show_more_colors = this.querySelector(".product-block-options__more-label")),
            (this.hidden_colors = this.querySelectorAll(".product-block-options__item--truncated")),
            this.preventFormSubmitOnEnter(),
            this.is_swatches && (theme.utils.setSwatchColors(this.inputs), this.current_value),
            this.updateLabelOnChange();   
        
        if (this.show_more_colors) {
            // Event listener to show the swatches on mobile for grid items
            //this.show_more_colors.addEventListener('touchend', this.handleShowMoreColorsClick, true);
        }

    }
    // handleShowMoreColorsClick(event) {
    //     event.stopPropagation();
    //     event.preventDefault();
    //     event.target.style.display = "none";

    //     if (this.hidden_colors) {
    //         this.hidden_colors.forEach(element => {
    //             element.style.display = "flex";
    //         });   
    //     }
    // }
    disconnectedCallback() {
        this.inputs.off("keydown.Radios change.Radios");
    }
    preventFormSubmitOnEnter() {
        this.inputs.on("keydown.Radios", (t) => {
            "Enter" === t.key && t.preventDefault();
        });
    }
    updateLabelOnChange() {
        this.inputs.on("change.Radios", (t) => {
            if (this.current_value) {
                this.current_value.textContent = t.target.value;   
            }
            if (this.current_color_link && t.target.value) {
                const lowercase_color = t.target.value.toLowerCase().replace(" ", "-");
                const new_link = '/collections/color/' + lowercase_color + this.filter
                this.current_color_link.href = new_link;
            }
        });
    }
}
customElements.define("radios-root", Radios);
